module.exports = __webpack_public_path__ + "static/media/pipes.0313427b.jpg";